import get from "lodash/get";
import { STRIPE } from "../constants";

const isTrial = (user) =>
  [STRIPE.PLANS.LAUNCH.trial, STRIPE.PLANS.V2.trial].includes(
    get(user, "stripe.plan")
  );
const isPremium = (user) =>
  [STRIPE.PLANS.V2.premiumMonthly, STRIPE.PLANS.V2.premiumAnnually].includes(
    get(user, "stripe.plan")
  );
const isAdmin = (user) => get(user, "admin", false) || user.hasRole("admin");
const isAmbassador = (user) =>
  get(user, "ambassador", false) || user.hasRole("ambassador");
const isCoach = (user) =>
  ["coach", "coachCanSubmit"].some((role) => user.hasRole(role));

const getAllPermissions = (user) => {
  return {
    trial: isTrial(user),
    admin: isAdmin(user),
    premium: isPremium(user),
    ambassador: isAmbassador(user),
    coach: isCoach(user),
  };
};

const getGreatestPermissionLevel = (permissions) => {
  if (!permissions) return undefined;

  if (permissions.admin) return "admin";
  if (permissions.ambassador) return "ambassador";
  if (permissions.coach) return "coach";
  if (permissions.premium) return "premium";

  return permissions.trial ? "trial" : "standard";
};

export default {
  isTrial,
  isPremium,
  isAdmin,
  isAmbassador,
  isCoach,
  getAllPermissions,
  getGreatestPermissionLevel,
};
